import { OpenApiApi } from "@/apis/v2/OpenApiApi";
import { CustomBackdropController } from "@/components/backdrop/default/v1";
import { customToast } from "@/components/toast/custom-react-toastify/v1";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const QUERY_KEY = 'OpenApiKey';

function handleError(error) {
    if (!error?.response) {
        customToast.error('서버와의 연결이 원활하지 않습니다.');
        return;
    }

    customToast.error(error.response?.data?.message);
}

export function useApiKeyQuery({ userPageId }) {
    return useQuery({
        queryKey: [QUERY_KEY, userPageId],
        enabled: !!userPageId,
        queryFn: async () => {
            const response = await OpenApiApi.getApiKey({ params: { userPageId } });

            return response?.data?.data;
        },
    });
}

export function useIssueApiKeyMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ body }) => {
            const response = await OpenApiApi.issueApiKey({ body });

            return response?.data?.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: handleError,
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useRevokeApiKeyMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ body }) => {
            const response = await OpenApiApi.revokeApiKey({ body });

            return response?.data?.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: handleError,
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}
